import { render, staticRenderFns } from "./priSettingsPublicListedCompany.vue?vue&type=template&id=1fb75e68"
import script from "./priSettingsPublicListedCompany.vue?vue&type=script&lang=js"
export * from "./priSettingsPublicListedCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports